<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionBillingAcademyUsersDropDownFilters"
  >
    <section
      v-if="showLoadingState"
      key="loadingState"
      class="m-dropdown-section"
    >
      <ul class="m-dropdown-list">
        <li>
          <a
            href="#"
            @click.prevent=""
          >
            <AtomLoadingSecondary/>
          </a>
        </li>
      </ul>
    </section>
    <form
      v-else
      key="academyUsersDropDownFilters"
      autocomplete="off"
      name="UsersDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
            <li>
              <a
                href="#"
                @click.prevent=""
              >
              {{ $t('mEditionBillingAcademyUsersDropDownFilters.input.academiaUrl.label') }}
              </a>
              <div class="m-dropdown-sublist">
                <input
                  v-model="academia_url"
                  class="a-input-primary"
                  name="academiaUrl"
                  :placeholder="$t('mEditionBillingAcademyUsersDropDownFilters.input.academiaUrl.placeholder')"
                  type="text"
                />
              </div>
            </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyUsersDropDownFilters.input.estado.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.habilitado"
                :elements="estados"
                key-field="id"
                name="habilitado"
                reference="habilitado"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyUsersDropDownFilters.input.actor.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.tipo"
                :elements="$filters.parameters.actors"
                key-field="id"
                name="actor"
                reference="actor"
                text-field="name"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyUsersDropDownFilters.input.nombre.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.nombre"
                class="a-input-primary"
                name="nombre"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyUsersDropDownFilters.input.email.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.email"
                class="a-input-primary"
                name="email"
                :placeholder="$t('mEditionBillingAcademyUsersDropDownFilters.input.email.placeholder')"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyUsersDropDownFilters.input.fecha.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionBillingAcademyUsersDropDownFilters.input.fecha.desde.placeholder')"
              />
              <span class="margin-bottom-xlarge"></span>
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionBillingAcademyUsersDropDownFilters.input.fecha.hasta.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyUsersDropDownFilters.input.pais.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.pais"
                :elements="paisesSelect"
                key-field="id_pais"
                name="pais"
                reference="pais"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionBillingAcademyUsersDropDownFilters.buttons.reload') }}
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionBillingAcademyUsersDropDownFilters.buttons.search') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyUsersDropDownFilters',

  props: {
    academiaUrlSeted: String,
    filterSeted: Object
  },

  data () {
    return {
      academia_url: '',

      disabledDates: {
        to: ''
      },

      estados: [
        {
          id: '',
          nombre: 'Todos los Estados'
        },
        {
          id: 1,
          nombre: 'Habilitados'
        },
        {
          id: 2,
          nombre: 'Deshabilitados'
        }
      ],

      filter: {
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        habilitado: '',
        limite: 10,
        nombre: '',
        pagina: 1,
        pais: '',
        tipo: ''
      },

      paises: [],
      showLoadingState: true,
      tipoActores: []
    }
  },

  computed: {
    paisesSelect () {
      let paises = [...this.paises]
      paises.unshift({
        id_pais: '',
        nombre: this.$t('mEditionBillingAcademyUsersDropDownFilters.input.pais.firstOption')
      })
      return paises
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.email = this.filterSeted.email
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.habilitado = this.filterSeted.habilitado
        this.filter.nombre = this.filterSeted.nombre
        this.filter.pais = this.filterSeted.pais
        this.filter.tipo = this.filterSeted.tipo

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    },

    academiaUrlSeted: {
      deep: true,

      handler () {
        this.academia_url = this.academiaUrlSeted
      },

      immediate: true
    }
  },

  created () {
    this.tipoActores = [...this.$filters.parameters.actors]
    this.readParametroPaises()
  },

  methods: {
    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionBillingAcademyUsersDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter, this.academia_url)
    }
  }
}
</script>
